import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IndexComponent } from "./index/index.component"
import { DetailComponent } from "./detail/detail.component"
import { LandingPageComponent } from './landing-page/landing-page.component'
import { LandingPageCourseVendorsComponent } from './landing-page-course-vendors/landing-page-course-vendors.component'
import { RedirectToDashboardComponent } from './redirect-to-dashboard/redirect-to-dashboard.component'
import { ReportsComponent } from './reports/reports.component';

const routes: Routes = [
	{
		path: "admin/courses-and-events",
		component: IndexComponent
	},
	{
		path: "admin/courses-and-events/add",
		component: DetailComponent
	},
	{
		path: "admin/courses-and-events/reports",
		component: ReportsComponent
	},
	{
		path: "admin/courses-and-events/:id/edit",
		component: DetailComponent
	},
	{
		path: "admin/courses-and-events/:id",
		component: DetailComponent
	},
	{
		path: "courses-and-events/:id/:name/event",
		component: LandingPageComponent
	},
	{ 
		path: '**',
		component: RedirectToDashboardComponent
	}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
